import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_zm63ypwage: FaireBrandEntity = {
  token: "b_zm63ypwage",
  type: "brand",
  name: "Organic Essentials",
  avatarUrl:
    "https://cdn.faire.com/fastly/cbecc6843f94bd3dee1accc370a68d98822fbf64585ff85c90f55782384da028.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/bf01abfdb764239b8796948f3e492f8624fc029409ea15a7daff27818e81e919.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/cbecc6843f94bd3dee1accc370a68d98822fbf64585ff85c90f55782384da028.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/bf01abfdb764239b8796948f3e492f8624fc029409ea15a7daff27818e81e919.jpeg",
  location: "York, GBR",
  minimumOrderDollars: 126,
  rating: 5,
  reviewCount: 38,
  isInsider: false,
  description:
    "Organic Essentials is a family  run business located in the beautiful Yorkshire countryside. Our business started with us hand picking natural fragrant botanicals from our garden / countryside and combining these with natural plant/flower essentials oils in an effort to combat our own personal ailments.\n\nSeeing the healing properties and health benefits we decided to share these with our friends and family and were exceptionally pleased to see the positive well being affects these elixirs were having.\n\nWe use the finest ethically sourced natural ingredients, full of organic goodness and every bath bomb is personally handmade and wrapped in eco-friendly tissue paper. \n\nOur bath bombs have been assessed by Cosmetic Safety Consultants and have passed with Cosmetic Safety Product Report (CSPR).\n\nWe have now created our own blend of floral, aromatic, earthy and citrus 130g large bath bombs, luxury bath blends, body & mind retox salts and gift sets so you can also experience the wonderful effects on your body, mind and definitely your soul!\n\nRelax, replenish, revitalise and enjoy!\n\nBest wishes,\n\nMaya",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:52:08.842Z",
    importedBy: "entity-db-cli",
  },
};
